import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"border":"1px solid #ccc"} }

import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import {
  onBeforeUnmount,
  onMounted,
  ref,
  shallowRef,
  watchEffect,
} from "vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import { uploadFileUsingPost } from "@/api/fileController";
import { Message } from "@arco-design/web-vue";

interface Props {
  initValueHtml: string;
}

const mode = "default";
// 内容 HTML
type InsertFnType = (url: string, alt: string, href: string) => void;

export default /*#__PURE__*/_defineComponent({
  __name: 'WangEditor',
  props: {
    initValueHtml: { default: () => {
    return "";
  } }
  },
  emits: ["updateValueHtml"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef();
const valueHtml = ref("");

onMounted(() => {
  valueHtml.value = props.initValueHtml;
});

const toolbarConfig = {};
const editorConfig = {
  placeholder: "请输入内容...",
  scroll: true,
  MENU_CONF: {
    uploadImage: {
      async customUpload(file: File, insertFn: InsertFnType) {
        const res = await uploadFileUsingPost({ biz: "oj_question" }, {}, file);
        if (res.data.code === 200) {
          const alt = file.name;
          const href = "";
          insertFn(res.data.data, alt, href);
        } else {
          Message.error("上传失败，" + res.data.message);
        }
      },
    },
  },
};
// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return;
  editor.destroy();
});

const handleCreated = (editor: any) => {
  editorRef.value = editor; // 记录 editor 实例，重要！
};

const emit = __emit;

watchEffect(() => {
  emit("updateValueHtml", valueHtml.value);
});

const setValueHtml = (html: string) => {
  valueHtml.value = html;
};

__expose({
  setValueHtml,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Toolbar), {
      style: {"border-bottom":"1px solid #ccc"},
      editor: editorRef.value,
      defaultConfig: toolbarConfig,
      mode: mode
    }, null, 8, ["editor"]),
    _createVNode(_unref(Editor), {
      style: {"min-height":"300px","overflow-y":"hidden"},
      modelValue: valueHtml.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((valueHtml).value = $event)),
      defaultConfig: editorConfig,
      mode: mode,
      onOnCreated: handleCreated
    }, null, 8, ["modelValue"])
  ]))
}
}

})